<template>
    <div>
        <div class="tit-wrap tit-wrap--unberline">
            <h2 class="tit">비밀번호 확인</h2>
            <div class="mt-1">* 회원정보 수정을 위해 비밀번호를 입력해주세요.</div>
        </div>
        <div class="table-style table-style--default">
            <div class="table-style__th">비밀번호</div>
            <div class="table-style__td">
                <v-row class="row--x-small">
                    <v-col cols="12">
                        <v-password-field v-model="password" v-bind="$attrs" placeholder="비밀번호" autocomplete="new-password" outlined hide-details />
                    </v-col>
                </v-row>
            </div>
        </div>
        <div class="mt-20px mt-md-30px">
            <v-row align="center" class="row--small">
                <v-spacer/>
                <v-col cols="auto">
                    <v-btn large color="primary" @click="confirm">확인</v-btn>
                </v-col>
                <v-spacer/>
            </v-row>
        </div>
    </div>
</template>

<script>
import api from "@/api"
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";
export default {
    components: {
        VPasswordField
    },
    data() {
        return {
            password: null
        }
    },
    methods: {
        async confirm() {
            if(this.validate()){
                const { success } = await api.v1.me.profile.confirm({
                    password: this.password
                })
                if(success){
                    alert("비밀번호가 인증되었습니다.")
                    this.$emit("confirm")
                } 
            }
        },
        validate() {
            try {
                if(!this.password) throw new Error("비밀번호를 입력해주세요.")
                return true;
            } catch(e) {
                alert(e.message)
            }
        }
    }
}
</script>

<style>

</style>